import { ANNOTATION_ZINDEX_RANGE_MAP } from "@/components/ui/annotations/annotation-zindex-range-map";
import { MarkupPolygonIcon } from "@faro-lotv/flat-ui";
import { Html } from "@react-three/drei";
import { type JSX } from "react";
import { Vector3 } from "three";
import { annotationColorToCss } from "./annotation-colors";
import { useAnnotationShapesStore } from "./annotation-shapes-store";

/** Same size as the pin of a hovered annotation */
const PIN_SIZE_PX = 30;

type PendingPointMarkerProps = {
  /** Where the point annotation will be created, in world coordinates */
  position: Vector3;
};

/** @returns the pin of the point annotation being created, so its place stays visible while the details are filled in */
export function PendingPointMarker({
  position,
}: PendingPointMarkerProps): JSX.Element {
  // The pin previews its color, or stays the default pin if none is picked
  const color = useAnnotationShapesStore((s) => s.pointColor);
  return (
    <Html
      position={position}
      center
      eps={-1}
      zIndexRange={ANNOTATION_ZINDEX_RANGE_MAP.full}
      style={{ pointerEvents: "none", transform: "translateY(-50%)" }}
    >
      <MarkupPolygonIcon
        aria-label="new annotation location"
        sx={{
          fontSize: PIN_SIZE_PX,
          color: color && annotationColorToCss(color),
        }}
      />
    </Html>
  );
}
